import {
    Avatar,
    Box,
    Card,
    CardContent,
    CardActions,
    Button,
    Grid,
    Typography
  } from '@material-ui/core';
  import { Link as RouterLink } from 'react-router-dom';


  import PublishIcon from '@material-ui/icons/Publish';
  import PayMethods from 'src/materials/FullScreenPay';
  import { green, blue } from '@material-ui/core/colors';
  import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
  import helper from 'src/utils/helpers';



  const TotalCustomers = ({data}) => {
    
    
    return(
    <Card
    sx={{ height: '200px' }}
  >
      <CardContent>
        <Grid
          container
          spacing={1}
        //   sx={{ justifyContent: 'space-between' }}
        >
          <Grid item className="flex-grow-1">
          <Typography
              color="primary"
              variant="h6"
            >
            CASH FUND
            </Typography>
            <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
                Current
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
             {helper.toCurrency(data.current)}
            </Typography>
          
              </Box>
              <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
                Fix Deposit
            </Typography>
              <Typography
              sx={{
                mr: 1
              }}
              color="textPrimary"
              variant="h5"
            >
             {helper.toCurrency(data.fixDeposit)}
            </Typography>
          
              </Box>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: blue[600],
                height: 56,
                width: 56
              }}
            >
              <AccountBalanceWalletIcon/>
            </Avatar>
          </Grid>
        </Grid>
        {/* <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            pt: 2
          }}
        >
          <ArrowUpwardIcon sx={{ color: green[900] }} />
          <Typography
            variant="body2"
            sx={{
              color: green[900],
              mr: 1
            }}
          >
            50%
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Increase on next loan
          </Typography>
        </Box> */}
      </CardContent>
      <CardActions className="center-element">
        <Button size="small" className="flex-grow-1" disabled>Cash In &nbsp;&nbsp; <PublishIcon fontSize="small"/></Button>
         <PayMethods type="cashout"/>

      </CardActions>
    </Card>
  );
  }
  
  export default TotalCustomers;
  